import Vue from "vue";
import Router from "vue-router";
import TourRoutes from "../views/tour/Routes";
import HomeRoutes from "../views/home/Routes";
import FlightRoutes from "../views/flight/Routes";
import ProfileRoutes from "../views/profile/Routes";
import hotelRoutes from "../views/hotel/Routes";
import voucherRoutes from "../views/vouchers/Routes";
import tourism from "../views/tourism/Routes";
import club from '../views/club/Routes';
import i18n from "../i18n";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      name: "main home",
      path: "/",
      component: () => import("@/views/home/Index"),
      children: HomeRoutes,
    },
    {
      name: "lcLanding",
      path: "/lcLanding/:businessId",
      component: () => import("@/views/home/LoyaltyClubLanding"),
      children: HomeRoutes,
    },
    {
      name: "forgetpassword",
      path: "/forgetpassword",
      component: () => import("@/views/signup/PdkForgetPassword"),
      children: HomeRoutes,
    },

    {
      name: "resetpassword",
      path: "/resetpassword",
      component: () => import("@/views/signup/PdkResetPassword"),
      children: HomeRoutes,
    },
    {
      name: "contactUs",
      path: "/contactus",
      component: () => import("@/views/home/ContactUs"),
      children: HomeRoutes,
    },
    {
      name: "aboutUs",
      path: "/aboutus",
      component: () => import("@/views/home/AboutUs"),
      children: HomeRoutes,
    },
    {
      name: "flightSearch",
      path: "/flightSearch",
      component: () => import("@/components/flight/FlightSearchList")
    },
    {
      name: "flightlist",
      path: "/flightlist",
      component: () => import("@/views/flight/FlightAvailList")
    },
    {
      name: "hotels",
      path: "/hotels",
      component: () => import("@/views/home/Hotels"),
      children: HomeRoutes,
    },
    {
      name: "flightHotels",
      path: "/flightHotels",
      component: () => import("@/views/home/flightHotels"),
      children: HomeRoutes,
    },
    {
      name: "login",
      path: "/login/:userName?",
      component: () => import("@/views/signup/PdkLogin"),
    },
    {
      name: "register",
      path: "/register",
      component: () => import("@/views/signup/PdkRegister"),
    },
    {
      name: "confirmpassword",
      path: "/confirmpassword",
      component: () => import("@/views/signup/PdkConfirmRegister"),
    },
    {
      name: "registerLc",
      path: "/registerLc/:businessId",
      component: () => import("@/views/signup/PdkRegisterLc"),
    },
    {
      name: "tour home",
      path: "/tour",
      component: () => import("@/views/tour/Index"),
      children: TourRoutes,
      meta: { roles: ['hotelFlight', 'SkorubaIdentityAdminAdministrator'] }
    },

    {
      name: "flight",
      path: "/flight",
      component: () => import("@/views/flight/Index"),
      children: FlightRoutes,
      meta: { roles: ['flight', 'SkorubaIdentityAdminAdministrator'] }
    },

    {
      name: "profile home",
      path: "/profile",
      component: () => import("@/views/profile/pages/Index"),
      children: ProfileRoutes,
      meta: { roles: ['profile', 'business', 'counters', 'tour', 'business', 'hotel', 'fasttrack', 'dolphin', 'SkorubaIdentityAdminAdministrator', 'customerClub'] },
    },

    {
      name: "hotel home",
      path: "/hotel",
      component: () => import("@/views/hotel/Index"),
      children: hotelRoutes,
      meta: { roles: ['hotel', 'SkorubaIdentityAdminAdministrator'] }
    },
    {
      name: "Vouchers",
      path: "/vouchers",
      component: () => import("@/views/vouchers/index"),
      children: voucherRoutes,
    },
    {
      name: "tourism home",
      path: "/tourism",
      component: () => import("@/views/tourism/Index"),
      meta: { roles: ['fasttrack', 'dolphin', 'SkorubaIdentityAdminAdministrator'] },
      children: tourism,
    },
    {
      name: "club",
      path: "/club",
      component: () => import("@/views/club/pages/Index"),
      children: club,
    },

    { path: "**", redirect: "/" },
  ],

},

);



